"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeFactoryInitializer = exports.ChallengeFactoryInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const challengeFactory_1 = require("./challengeFactory");
const CHALLENGE_FACTORY_ERROR = 'Challenge factory initialization error';
class ChallengeFactoryInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(CHALLENGE_FACTORY_ERROR, message);
    }
}
exports.ChallengeFactoryInitializationError = ChallengeFactoryInitializationError;
//XHR necesita el authoriser y el authoriser necesita xhr
//Hacer un inicializador de ChallengeFactory
//Tampoc... authoriser necesitará de challengeFactory, challengeFactory necesita de  API y API necesita de authoriser...
//Authoriser no necesita de ninguno. Challenge factory necesita de authoriser y  API para hacer el setChallengeFactory. ApI Necesita de authoriser
class ChallengeFactoryInitializer extends web_ui_framework_1.Initializer {
    constructor(API, session, manager, authoriser) {
        super([API, session, manager, authoriser]);
        this.launch = () => {
            try {
                const challengeFactory = new challengeFactory_1.ChallengeFactory(this.API.getInitialized(), this.session.getInitialized(), this.manager.getInitialized());
                this.authoriser.getInitialized().setChallengeFactory(challengeFactory);
                return challengeFactory;
            }
            catch (e) {
                throw new ChallengeFactoryInitializationError(e);
            }
        };
        this.manager = manager;
        this.session = session;
        this.API = API;
        this.authoriser = authoriser;
    }
}
exports.ChallengeFactoryInitializer = ChallengeFactoryInitializer;
//# sourceMappingURL=challengeFactory.initializer.js.map